import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";

/**
 * Composable untuk mengakses breakpoint berbasis Tailwind yang sudah disesuaikan
 * dengan kebutuhan layout template Anggun Praya.
 *
 * Composable ini membungkus `useBreakpoints()` dari VueUse dan menambahkan
 * beberapa breakpoint kustom seperti `xs`, `mdUp`, `custom`, dan `3xl`
 * agar naming di komponen tetap konsisten antar template.
 *
 * @returns Objek helper breakpoint yang siap dipakai di komponen atau composable lain
 */
export function useBreakpointTailwind() {
  const breakpoints = useBreakpoints({
    ...breakpointsTailwind,
    "xs": 480,
    "mdUp": 896,
    "custom": 1700,
    "3xl": 1920,
  });

  const xs = breakpoints.xs;
  const sm = breakpoints.sm;
  const md = breakpoints.md;
  const mdUp = breakpoints.mdUp;
  const lg = breakpoints.lg;
  const xl = breakpoints.xl;
  const xl2 = breakpoints["2xl"];
  const custom = breakpoints.custom;
  const xl3 = breakpoints["3xl"];

  return {
    xs,
    sm,
    md,
    mdUp,
    lg,
    xl,
    "2xl": xl2,
    custom,
    "3xl": xl3,
  };
}
